<template>
  <transition :css="false" @enter="enter" @leave="leave">
    <div class="ControlsComp">
      <div
        class="ControlsComp__touch"
        v-for="(code, name) in touchs"
        :class="'is-' + name"
        @touchstart="touchstart(code)"
        @touchend="touchend(code)"
      >
        <svg class="ControlsComp__arrow">
          <use :xlink:href="'#' + require('./sprite/arrow-control.svg').default.id" />
        </svg>
      </div>
    </div>
  </transition>
</template>

<script>
import * as BABYLON from 'babylonjs'

export default {
  name: 'ControlsComp',
  data: () => ({
    touchs: {
      'top': 87,
      'left': 65,
      'bottom': 83,
      'right': 68
    }
  }),
  beforeDestroy() {
    this.$parent.$camera.inputs.attached.keyboard._keys = []
  },

  mounted() {

    // var camera = this.$parent.$camera
    //     // camera.inputs.removeByType("FreeCameraKeyboardMoveInput");
    //     camera.inputs.removeByType("FreeCameraMouseInput");

    // var FreeCameraSearchInput = function (touchEnabled) {
    //     if (touchEnabled === void 0) { touchEnabled = true; }
    //     this.touchEnabled = touchEnabled;
    //     this.buttons = [0, 1, 2];
    //     this.angularSensibility = 2000.0;
    //     this.restrictionX = 100;
    //     this.restrictionY = 60;
    // }

    // FreeCameraSearchInput.prototype.attachControl = function (noPreventDefault) {
    //   var _this = this;
    //   var engine = this.camera.getEngine();
    //   var element = engine.getInputElement();
    //   var angle = {x:0, y:0};
    //   if (!this._pointerInput) {
    //     this._pointerInput = function (p, s) {
    //       var evt = p.event;
    //       if (!_this.touchEnabled && evt.pointerType === "touch") {
    //           return;
    //       }
    //       if (p.type !== BABYLON.PointerEventTypes.POINTERMOVE && _this.buttons.indexOf(evt.button) === -1) {          
    //           return;
    //       }
    //       if (p.type === BABYLON.PointerEventTypes.POINTERDOWN) {          
    //           try {
    //               evt.srcElement.setPointerCapture(evt.pointerId);
    //           }
    //           catch (e) {
    //               //Nothing to do with the error. Execution will continue.
    //           }
    //           _this.previousPosition = {
    //               x: evt.clientX,
    //               y: evt.clientY
    //           };
    //           if (!noPreventDefault) {
    //               evt.preventDefault();
    //               element.focus();
    //           }
    //       }
    //       else if (p.type === BABYLON.PointerEventTypes.POINTERUP) {          
    //           try {
    //               evt.srcElement.releasePointerCapture(evt.pointerId);
    //           }
    //           catch (e) {
    //               //Nothing to do with the error.
    //           }
    //           _this.previousPosition = null;
    //           if (!noPreventDefault) {
    //               evt.preventDefault();
    //           }
    //       }
    //       else if (p.type === BABYLON.PointerEventTypes.POINTERMOVE) {            
    //         if (!_this.previousPosition || engine.isPointerLock) {
    //             return;
    //         }
    //         var offsetX = evt.clientX - _this.previousPosition.x;
    //         var offsetY = evt.clientY - _this.previousPosition.y;                   
    //         angle.x +=offsetX;
    //         angle.y -=offsetY;  
    //         if(Math.abs(angle.x) > _this.restrictionX )  {
    //             angle.x -=offsetX;
    //         }
    //         if(Math.abs(angle.y) > _this.restrictionY )  {
    //             angle.y +=offsetY;
    //         }       
    //         if (_this.camera.getScene().useRightHandedSystem) {
    //             if(Math.abs(angle.x) < _this.restrictionX )  {
    //                 _this.camera.cameraRotation.y -= offsetX / _this.angularSensibility;
    //             }
    //         }
    //         else {
    //             if(Math.abs(angle.x) < _this.restrictionX )  {
    //                 _this.camera.cameraRotation.y += offsetX / _this.angularSensibility;
    //             }
    //         }
    //         if(Math.abs(angle.y) < _this.restrictionY )  {
    //             _this.camera.cameraRotation.x += offsetY / _this.angularSensibility;
    //         }
    //         _this.previousPosition = {
    //             x: evt.clientX,
    //             y: evt.clientY
    //         };
    //         if (!noPreventDefault) {
    //             evt.preventDefault();
    //         }
    //       }
    //     }
    //   }
    //   this._onSearchMove = function (evt) {       
    //     if (!engine.isPointerLock) {
    //         return
    //     }       
    //     var offsetX = evt.movementX || evt.mozMovementX || evt.webkitMovementX || evt.msMovementX || 0;
    //     var offsetY = evt.movementY || evt.mozMovementY || evt.webkitMovementY || evt.msMovementY || 0;
    //     if (_this.camera.getScene().useRightHandedSystem) {
    //         _this.camera.cameraRotation.y -= offsetX / _this.angularSensibility;
    //     }
    //     else {
    //         _this.camera.cameraRotation.y += offsetX / _this.angularSensibility;
    //     }
    //     _this.camera.cameraRotation.x += offsetY / _this.angularSensibility;
    //     _this.previousPosition = null;
    //     if (!noPreventDefault) {
    //         evt.preventDefault();
    //     }
    //   }
    //   this._observer = this.camera.getScene().onPointerObservable.add(this._pointerInput, BABYLON.PointerEventTypes.POINTERDOWN | BABYLON.PointerEventTypes.POINTERUP | BABYLON.PointerEventTypes.POINTERMOVE);
    //   element.addEventListener("mousemove", this._onSearchMove, false);
    // }
    // FreeCameraSearchInput.prototype.detachControl = function () {
    //   var engine = this.camera.getEngine();
    //   var element = engine.getInputElement();
    //   if (this._observer && element) {
    //       this.camera.getScene().onPointerObservable.remove(this._observer);
    //       element.removeEventListener("mousemove", this._onSearchMove);
    //       this._observer = null;
    //       this._onSearchMove = null;
    //       this.previousPosition = null;
    //   }
    // }
    // FreeCameraSearchInput.prototype.getClassName = function () {
    //   return "FreeCameraSearchInput";
    // }
    // FreeCameraSearchInput.prototype.getSimpleName = function () {
    //   return "MouseSearchCamera";
    // }

    // camera.inputs.add(new FreeCameraSearchInput())

  },

  methods: {
    touchstart(touch) {
      console.log(touch);
      this.$parent.$camera.inputs.attached.keyboard._keys = [touch]
    },
    touchend(touch) {
      this.$parent.$camera.inputs.attached.keyboard._keys = []
    },
    enter(el, done) {
      TweenMax.staggerFrom(el.querySelectorAll('.ControlsComp__touch'), 1, { alpha: 0 }, .1, done)
    },
    leave(el, done) {
      TweenMax.staggerTo(el.querySelectorAll('.ControlsComp__touch'), 1, { alpha: 0 }, .1, done)
    }
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.ControlsComp
  position fixed
  width 168px
  user-select none
  bottom 20px
  left 20px
  z-index 999999

  &__arrow
    fill black
    width 15px
    height 15px
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)

  &__touch
    width 50px
    height 50px
    background rgba(white, 1)
    border 1px solid white
    cursor pointer
    border-radius 25px
    position relative
    margin 2px

    &.is-top
      margin-left 56px
      transform rotate(0deg)
    &.is-left
      float left
      .ControlsComp__arrow
        transform translate(-50%, -50%) rotate(-90deg)
    &.is-bottom
      float left
      .ControlsComp__arrow
        transform translate(-50%, -50%) rotate(180deg)
    &.is-right
      float left
      .ControlsComp__arrow
        transform translate(-50%, -50%) rotate(90deg)

</style>



// WEBPACK FOOTER //
// src/components/controls/ControlsComp.vue